import FizConfig from "../FizConfig.js";

var
    // URL of the Google Loader script to load Google Maps dynamically
  GOOGLE_LOADER_API = "//maps.googleapis.com/maps/api/js?libraries=places&callback=gmaploadedglobal&key="+FizConfig.GOOGLE_MAPS_V3,
  loaded = false,
  loading = false,
  waitingLoadCallbacks = [];

window.gmaploadedglobal = function(){
  loaded = true;
  waitingLoadCallbacks.forEach(callback=>callback())
  waitingLoadCallbacks = [];
}

function loadThen(callback){
  if(loaded){
    callback();
    return;
  }
  waitingLoadCallbacks.push(callback);
  if(loading){
    return;
  }
  loading = true;
  var script = document.createElement('script');
  script.async = true;
  script.src = GOOGLE_LOADER_API
  document.head.appendChild(script);
}

export {loadThen};